// extracted by mini-css-extract-plugin
module.exports = {"popUp":"PopUp_popUp__GWW3H","inSubmit":"PopUp_inSubmit__3ePGq"};